import { EuiSelect } from '@equipmentshare/ds2'
import useReasonOptions from './useReasonOptions'
import { ManualAdjustmentReasonType, ReasonPickerProps } from './types'

export default function ReasonPickerEui( {
	selectedReason,
	onChange,
	reasonType,
	filterOptions,
	// MUI-only (FormRow's floating-label injection): the EUI branch gets its
	// label from real `EuiFormRow`, so these are destructured only to keep them
	// out of the `...props` spread below.
	/* eslint-disable @typescript-eslint/no-unused-vars */
	label,
	error,
	helperText,
	/* eslint-enable @typescript-eslint/no-unused-vars */
	...props
}: ReasonPickerProps ) {
	const { options, reasons, loading } = useReasonOptions( { reasonType, filterOptions } )

	const handleChange = ( event: React.ChangeEvent<HTMLSelectElement> ) => {
		const reasonStr = event.currentTarget.value as ManualAdjustmentReasonType
		const reasonObj = reasons.find( ( reason ) => reason?.reason === reasonStr )
		if ( reasonObj ) {
			onChange( reasonStr, reasonObj )
		}
	}

	return (
		<EuiSelect
			options={options}
			isLoading={loading}
			value={selectedReason}
			onChange={handleChange}
			hasNoInitialSelection
			{...props}
		/>
	)
}
